import { useState } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import { useLocation } from 'react-router-dom';
import { LuMenu, LuShoppingCart, LuX } from "react-icons/lu";
import styles from "./MobileNavBar.module.css"

const DEFAULT_CLASSES = {
  container: styles.navbar,
  logoContainer: styles["navbar-logo"],
  logoImage: styles["navbar-logo-image"],
  navList: styles["navbar-nav"],
  navItem: styles["nav-link"]
};

const DEFAULT_LOGO = {
  image: null,
  path: "/"
};


function NavBar({ navItems = [], navLogo = DEFAULT_LOGO, navClassesOverride = {} }) {
  const classes = { ...DEFAULT_CLASSES, ...navClassesOverride };
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const cartItem = navItems.find((item) => item.name === "CART");
  const cartCount = cartItem?.badge?.value;
  const menuItems = navItems.filter((item) => item.name !== "CART");

  const handleLogoClick = (event) => {
    if (location.pathname === "/home") {
      event.preventDefault();
      window.history.replaceState(null, "", "/home");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleNavItemClick = (item) => {
    setMenuOpen(false);
    if (item?.scrollToTop) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  };

  return (
    <nav className={classes.container}>
      <div className={styles.navbarRow}>
        <div className={classes.logoContainer}>
          {navLogo.image && (
            <NavHashLink to={navLogo.path} onClick={handleLogoClick}>
              <img src={navLogo.image} alt="Logo" className={classes.logoImage} />
            </NavHashLink>
          )}
        </div>
        <div className={styles.navbarActions}>
          <NavHashLink
            to={cartItem?.path || "/cart"}
            className={styles.cartButton}
            aria-label={cartCount > 0 ? `Cart with ${cartCount} items` : "Cart"}
            onClick={() => handleNavItemClick(cartItem)}
          >
            <LuShoppingCart size={22} />
            {cartCount > 0 && <span className={styles.cartBadge}>{cartCount}</span>}
          </NavHashLink>
          <button
            type="button"
            className={styles.menuButton}
            aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((isOpen) => !isOpen)}
          >
            {menuOpen ? <LuX size={24} /> : <LuMenu size={24} />}
          </button>
        </div>
      </div>
      <ul className={`${classes.navList} ${menuOpen ? styles.navbarNavOpen : ""}`}>
        {menuItems.map((item, index) => (
          <li key={index}>
            <NavHashLink
              to={item.path}
              className={styles["nav-link"]}
              onClick={() => handleNavItemClick(item)}
            >
              {item.name}
              {item.badge?.value > 0 && <span className={styles.cartBadge}>{item.badge.value}</span>}
              {item.icon && <span>{item.icon}</span>}
            </NavHashLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default NavBar;